import { render, staticRenderFns } from "./VKXHHUHW.vue?vue&type=template&id=673cf590&scoped=true&"
import script from "./VKXHHUHW.vue?vue&type=script&lang=js&"
export * from "./VKXHHUHW.vue?vue&type=script&lang=js&"
import style0 from "./VKXHHUHW.vue?vue&type=style&index=0&id=673cf590&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673cf590",
  null
  
)

export default component.exports